import firebase from "firebase/app";
import moment from "moment";
import router from "../../router/index";

const state = {
  player: null,
  error: null,
};

const mutations = {
  SET_PLAYER(state, player) {
    state.player = player;
  },
  SET_ERROR(state, err) {
    state.error = err;
  },
};

const actions = {


  initializePlayer({ dispatch, commit, rootState, getters }, data) {

    let player = null;
    rootState.Database.db
      .collection("devices")
      .where("pairingCode", "==", data.pid)
      .get()
      .then(querySnapshot => {
        querySnapshot.forEach(doc => {
          if (doc.data().deleted) {
            return;
          }
          if (doc.data().pairingCode === data.pid && doc.data().enabled) {
            player = {
              ...doc.data(),
              id: doc.id
            };
            router.push("Loading");

            commit("SET_PLAYER", player);
            dispatch("downloadCategories", player.categories)
              .then(() => dispatch("downloadStatistics", player.statsId))
              .then(() => dispatch("downloadSchedule", player.scheduleId))
              .then(() => dispatch("downloadConfig"))
              .then(() => dispatch("initDeviceRealtimeControl", player.id))
              .then(() => {
                if (getters.getPlayerIsStudio) {
                  return dispatch("initializeLivechannel", player.live.liveChannels.id);
                }
                
                return new Promise(resolve => resolve(true));
                
              }).then(() => {
                dispatch("startTimer");

                // Set online status
                doc.ref.update({
                  status: moment().format("YYYY-MM-DD HH:mm")
                });
                setTimeout(() => {
                  router.push("Home");
                }, 1000);
              });
          } else {
            throw new Error("Player not found or is not enabled");
          }

        });
      })
      .catch(console.error);
  },

  initDeviceRealtimeControl({ rootState, dispatch }, playerId) {

    rootState.Database.db.collection("devices").doc(playerId).collection("control").doc("device")
      .onSnapshot({
        // Listen for document metadata changes
        includeMetadataChanges: true
      }, doc => {
        if (doc.exists) {
          if (doc.data().executed === false) {
            doc.ref.set({
              deviceReceived: moment().format("YYYY-MM-DD HH:mm"),
              executed: true,
            }, { merge: true });
            setTimeout(() => {
              dispatch("realtimeControl", doc.data());
            }, 500);

          }
        }
      });


  },

  updateRealtimeControlData({ rootState, getters }, data) {
    const devRef = rootState.Database.db.collection("devices")
      .doc(getters.getPlayer.id).collection("control").doc("device");
    return devRef.update({ data });
  },

  connect({ dispatch, commit }, data) {

    // Login
    firebase.auth().signInWithEmailAndPassword(data.email, data.password).then(() => {

      // Sync
      dispatch("initializePlayer", data);

    }).catch(error => {
      commit("SET_ERROR", error.message);
    });
  },
  dismissAlert({ commit }) {
    commit("SET_ERROR", null);
  }
};

const getters = {
  getPlayer(state) {
    return state.player;
  },
  getErrorMessage(state) {
    return state.error;
  },
  getLoadingProgress(state) {
    return state.loadingProgress;
  },
  getPlayerLightScenes(state) {
    if (state.player && state.player.lights && state.player.lights.scenes) {
      return state.player.lights.scenes;
    }

    return [];
  },
  getPlayerLightShows(state) {
    if (state.player && state.player.lights && state.player.lights.shows) {
      return state.player.lights.shows;
    }

    return [];
  },
  getPlayerRoomLightsEnabled(state) {
    if (state.player && state.player.lights && state.player.lights.roomLights) {
      return state.player.lights.roomLights;
    }
    
    return false;
    
  },
  getPlayerInstructorLightEnabled(state) {
    if (state.player && state.player.lights && state.player.lights.instructorLights) {
      return state.player.lights.instructorLights;
    }
    
    return false;
    
  },
  getPlayerIsStudio(state) {
    if (state.player && state.player.live && state.player.live.type === "studio") {
      return true;
    }
    return false;
  },
  getDisplay(state) {
    if (state.player !== null && state.player.config.display !== undefined) {
      return state.player.config.display;
    }
    
    return null;
    
  },
  getDisplayDriver(state) {
    if (state.player && state.player.config.display && state.player.config.display.driver) {
      return state.player.config.display.driver;
    }
    
    return null;
    
  },
  getDisplayExists(state) {
    return state.player && state.player.config.display;    
  },
};

export default {
  state,
  getters,
  actions,
  mutations
}; 



// WEBPACK FOOTER //
// ./src/store/modules/Player.js